/* eslint-disable operator-linebreak */
import PropTypes from 'prop-types';

import styled from 'styled-components';

const StyledButton = styled.button`
  border: none;
  width: ${(props) => props.$width};
  color: ${(props) => props.$textColor};
  background: ${(props) => props.$backgroundColor};
  height: 35px;
  text-transform: uppercase;
  outline: 1px solid ${(props) => props.$backgroundColor};
  outline-offset: 3px;
  font-family: ${(props) => props.theme.fonts.sansSerif};
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  padding: 10px 12px;
  ${(props) => props.styles}
  ${(props) =>
    !props.$active &&
    'color: var(--darkGrey); cursor: default; text-decoration: none; opacity: 0.4;'}

  ${(props) =>
    props.$active &&
    `text-decoration: none;
  &:hover {
    color: ${props.$hoverTextColor};
    background: ${props.$hoverBgColor};
    text-decoration: none;
    outline: 1px solid ${props.$hoverBgColor};
  }
  `}
`;

export const PrimartyBtn = ({
  width = 'initial',
  label,
  backgroundColor = '#fff',
  hoverTextColor = '#fff',
  hoverBgColor = '#ffa73c',
  hoverColor = 'var(--red)',
  textColor = 'var(--darkGrey)',
  clickEvent,
  active,
  style
}) => (
  <StyledButton
    $width={width}
    $hoverTextColor={hoverTextColor}
    label={label}
    $hoverBgColor={hoverBgColor}
    $hoverColor={hoverColor}
    onClick={(e) => clickEvent(e)}
    $active={active}
    $textColor={textColor}
    style={style}
    $backgroundColor={backgroundColor}
  >
    {label}
  </StyledButton>
);

PrimartyBtn.propTypes = {
  label: PropTypes.string.isRequired,
  hoverTextColor: PropTypes.string,
  hoverBgColor: PropTypes.string,
  textColor: PropTypes.string,
  backgroundColor: PropTypes.string,
  hoverColor: PropTypes.string,
  clickEvent: PropTypes.func.isRequired,
  active: PropTypes.bool,
  style: PropTypes.objectOf(PropTypes.string)
};
